<div class="border-top pt-2">
    <form [formGroup]="checkCreditForm" class="row mb-1">
        <div class="col" style="padding-top: .4rem;">
            <div class="form-check">
                <input type="checkbox"
                       class="form-check-input"
                       formControlName="agreeForCreditCheck"
                       id="creditCheckConsent"
                       (change)="onAgreeToggled()"/>
                <label class="form-check-label" for="creditCheckConsent">
                    <b>Jag godkänner inhämtning av kreditupplysning för kreditbedömning.</b>
                </label>
            </div>
        </div>
        <div class="col-auto">
            <button type="button"
                    class="btn btn-primary"
                    (click)="checkCreditRating()"
                    [disabled]="isLoading || checkCreditForm.invalid">
                <span
                        class="spinner-border spinner-border-sm me-1"
                        *ngIf="isLoading"
                ></span>
                Nästa
            </button>
        </div>
    </form>
    @if(creditCheckRejected) {
        <div class="row">
            <div class="col">
                <div class="col alert alert-warning">
                    <div class="alert-body">
                        <p>
                            <b>Kreditprövning:</b><br>
                            <span [innerHTML]="getRejectMessageWithEmailLinks()"></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    }
    @if(creditCheckFailRequest) {
        <div class="row">
            <div class="col">
                <div class="col alert alert-warning">
                    <div class="alert-body">
                        <p>
                            <b>Kreditprövning:</b><br>
                            <span>Det verkar som att vi har tekniska problem med att skicka in kreditprövningen. Försök igen senare.</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
